export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-34',
  growthbookFeatures: ['supp', 'thankyou_tips'],
  sexologyUpsellEnabled: false,
};
